module.exports = __webpack_public_path__ + "static/media/Statements.c9b7e7dd.svg";